/** @format */

import React, { useEffect, useState } from "react";
import { Button, Table,Space } from "antd";

import { useNavigate } from "react-router";
import { InputText } from "primereact/inputtext";
import { Box } from "@material-ui/core";
import moment from "moment";
import { GetPayment } from "../../services/Api/Api";

const Payment = () => {
	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [userBackupData, setUserBackupData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);

	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 100,
		},
		sortField: null,
		sortOrder: null,
	});

	// const getAmount = (record) => {
	// 	if (record.payment_type === "DONATION") {
	// 		return record.donation_amount;
	// 	}
	// 	return record.amount;
	// };

	const columns = [
		{
			title: "S.No.",
			dataIndex: "index",
			width: "5%",
		},

		{
			title: "Name",
			dataIndex: "payer_name",
			width: "10%",
			render: (name) => <span>{name ? name : "--"}</span>,
		},

		{
			title: "Email",
			dataIndex: "payer_email",
			width: "18%",
			render: (email) => <span>{email ? email : "--"}</span>,
		},

		{
			title: "Payment Type",
			dataIndex: "payment_type",
			width: "12%",
			render: (type) => (
				<span
					style={{
						fontWeight: 600,
						color: type === "DONATION" ? "#1565c0" : "#2e7d32",
					}}
				>
					{type === "DONATION" ? "Donation" : "Package"}
				</span>
			),
		},

		{
			title: "Package",
			key: "package_name",
			width: "10%",
			render: (_, record) => {
				if (record.payment_type === "PACKAGE") {
					return (
						<span style={{ fontWeight: 600, color: "#2e7d32" }}>
							{record.package?.name || "--"}
						</span>
					);
				}
				return <span style={{ color: "#999" }}>--</span>;
			},
		},

		{
			title: "Amount",
			key: "amount",
			width: "10%",
			render: (_, record) => (
				<strong>
					{record.currency} {record.amount}
				</strong>
			),
		},

		{
			title: "Status",
			dataIndex: "payment_status",
			width: "10%",
			render: (status) => {
				const colorMap = {
					PENDING: "#f9a825",
					SUCCESS: "#2e7d32",
					FAILED: "#d32f2f",
					CANCELED: "#d32f2f",
				};

				return (
					<span
						style={{
							color: colorMap[status] || "#000",
							fontWeight: 600,
						}}
					>
						{status}
					</span>
				);
			},
		},

		{
			title: "Transaction Date",
			dataIndex: "created_at",
			width: "30%",
			render: (date) => moment(date).format("DD MMM YYYY, hh:mm A"),
		},
	];

	// Get all users
	const getData = async (params = {}) => {
		try {
			setLoading(true);
			let result = await GetPayment(localStorage.getItem("adminToken"), params);
			// Adding index for serial number
			const newData = result.data.data.map((item, index) => ({
				...item,
				index: index + 1,
			}));
			setData(newData);
			setUserBackupData(newData);
			// console.log(newData, "newData");
		} catch (e) {
			console.log(e);
			if (e.response && e.response.status === 403) {
				navigate("/error401");
				console.log("Access denied. You do not have the required permissions.");
			} else {
				console.log("Error loading data. Please try again later.");
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getData({
			page: tableParams.pagination.current,
			pageSize: tableParams.pagination.pageSize,
			sortField: tableParams.sortField,
			sortOrder: tableParams.sortOrder,
		});
	}, [tableParams]);

	const handleTableChange = (pagination, filters, sorter) => {
		setTableParams({
			pagination,
			filters,
			sortField: sorter.field,
			sortOrder: sorter.order,
		});
	};

	const onSearch = (searchField) => {
		const value = searchField.toLowerCase();

		const filtered = userBackupData.filter((item) => {
			const name = item?.payer_name?.toLowerCase() || "";
			const email = item?.payer_email?.toLowerCase() || "";

			return name.includes(value) || email.includes(value);
		});

		setData(filtered);
	};

	const exportToCSV = () => {
		if (!data.length) return;

		const headers = [
			"Name",
			"Email",
			"Payment Type",
			"Package",
			"Amount",
			"Currency",
			"Status",
			"Transaction Date",
		];

		const rows = data.map((item) => [
			item.payer_name || "--",
			item.payer_email || "--",
			item.payment_type,
			item.package?.name || "--",
			item.amount,
			item.currency,
			item.payment_status,
			moment(item.created_at).format("DD MMM YYYY, hh:mm A"),
		]);

		const csvContent = [headers, ...rows]
			.map((e) => e.map((v) => `"${v}"`).join(","))
			.join("\n");

		const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
		const url = URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = url;
		link.setAttribute("download", "payments.csv");
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: (selectedRowKeys) => {
			setSelectedRowKeys(selectedRowKeys);
		},
	};

	return (
		<Box>
			<Box
  display="flex"
  justifyContent="space-between"
  alignItems="center"
  marginBottom="20px"
>
  <div>
    <h3 className="page-title">PAYMENT MANAGEMENT</h3>
    <p className="page-sub-title">View Payment History</p>
  </div>

  <Space size={12} align="center">
    <Button
      type="primary"
      style={{ height: 38 }}
      onClick={exportToCSV}
    >
      Export CSV
    </Button>

    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        type="search"
        onChange={(e) => onSearch(e.target.value)}
        placeholder="Search..."
        style={{ height: 38 }}
      />
    </span>
  </Space>
</Box>

			<Table
				// rowSelection={rowSelection} // Add row selection
				columns={columns}
				rowKey={(record) => record.id}
				dataSource={data}
				pagination={tableParams.pagination}
				loading={loading}
				onChange={handleTableChange}
			/>
		</Box>
	);
};

export default Payment;
